import React, { Component, Fragment } from 'react';
import { withNamespaces } from 'react-i18next';
import { inject, observer } from 'mobx-react';
import { Link } from 'react-router-dom';

@withNamespaces()
@inject('store')
@observer
class UserInfo extends Component {
    constructor(props) {
        super(props);

        this.state = {
            open: false,
        };

        this.toggle = this.toggle.bind(this);
        this.logout = this.logout.bind(this);
    }

    toggle() {
        this.setState(state => ({
            open: !state.open,
        }));
    }

    logout() {
        this.props.store.auth.logout();
    }

    render() {
        const { user } = this.props.store;
        const { loading, email } = user;

        if (loading) {
            return null;
        }

        const { t } = this.props;
        const { open } = this.state;

        return (
            <Fragment>
                <button type="button" className="dropdown sm-m-r-5 bg-transparent border-0" onClick={this.toggle}>
                    <div className="d-flex">
                        <div className="p-t-10 m-r-10 hidden-xs">
                            <span className="text-muted semi-bold">{email}</span>
                        </div>
                        <div className="pull-right thumbnail-wrapper d32 circular inline">
                            <div className="bg-primary" style={{width: 32, height: 32}}>
                                <span className="text-white-50">{email[0].toUpperCase()}</span>
                            </div>
                            {/*<img src="temp/img/profiles/avatar.jpg" alt="" data-src="assets/img/profiles/avatar.jpg"
                                 data-src-retina="assets/img/profiles/avatar_small2x.jpg" width="32" height="32"
                            />*/}
                        </div>
                    </div>
                </button>
                { open && (
                    <div className="dropdown-menu dropdown-menu-right profile-dropdown show m-r-25" role="menu">
                        <a href="/account" className="dropdown-item"><i className="pg-settings_small" /> {t('NAVBAR.ACCOUNT')}</a>
                        <Link to="/family/manage" className="dropdown-item"><i className="pg-settings_small" /> {t('NAVBAR.FAMILY')}</Link>
                        {/*<a href="#" className="dropdown-item"><i className="pg-outdent" /> Feedback</a>*/}
                        {/*<a href="#" className="dropdown-item"><i className="pg-signals" /> Help</a>*/}
                        <button onClick={this.logout} type="button" className="clearfix bg-master-lighter dropdown-item">
                            <span className="pull-left">{t('NAVBAR.LOGOUT')}</span>
                            <span className="pull-right"><i className="pg-power" /></span>
                        </button>
                    </div>
                )}
                {/*<div className="pull-left p-r-10 fs-14 font-heading d-lg-inline-block d-none">
                    <span className="semi-bold">{user.email}</span>
                </div>
                <div className="dropdown sm-m-r-5">
                    <button className="profile-dropdown-toggle" type="button" data-toggle="dropdown"
                        aria-haspopup="true" aria-expanded="false"
                    >
                        <span className="pull-right thumbnail-wrapper d32 circular inline">
                            <img src="temp/img/profiles/avatar.jpg" alt="" data-src="assets/img/profiles/avatar.jpg"
                                data-src-retina="assets/img/profiles/avatar_small2x.jpg" width="32" height="32"
                            />
                        </span>
                    </button>
                    <div className="dropdown-menu dropdown-menu-right profile-dropdown" role="menu">
                        <a href="#" className="dropdown-item"><i className="pg-settings_small" /> Settings</a>
                        <a href="#" className="dropdown-item"><i className="pg-outdent" /> Feedback</a>
                        <a href="#" className="dropdown-item"><i className="pg-signals" /> Help</a>
                        <a href="#" className="clearfix bg-master-lighter dropdown-item">
                            <span className="pull-left">Logout</span>
                            <span className="pull-right"><i className="pg-power" /></span>
                        </a>
                    </div>
                </div>*/}
            </Fragment>
        );
    }
}

export default UserInfo;


// WEBPACK FOOTER //
// ./src/components/base/secure/header/user-info.js